import React from 'react'
import { motion } from 'motion/react'

import type { CollapsibleContextProps } from './CollapsibleContext'
import { useCollapsibleContext } from './CollapsibleContext'

type CollapsibleContentProps = {
  children: (contextState: CollapsibleContextProps) => React.ReactNode
}

export const CollapsibleContent = ({
  children: renderChildren,
}: CollapsibleContentProps) => {
  const contextState = useCollapsibleContext()

  const initialValue = contextState.defaultIsExpanded ? 'expanded' : 'collapsed'

  return (
    <motion.div
      defaultValue={initialValue}
      initial={initialValue}
      transition={{ duration: 0.28, ease: [0.73, 0.06, 0.31, 1.01] }}
      variants={{
        collapsed: {
          height: '0px',
          opacity: 0,
          visibility: 'hidden',
          overflow: 'hidden',
        },
        expanded: {
          height: 'auto',
          overflow: 'visible',
          opacity: 1,
          visibility: 'visible',
        },
      }}
      animate={contextState.isExpanded ? 'expanded' : 'collapsed'}
    >
      {renderChildren(contextState)}
    </motion.div>
  )
}
